import { Routes } from '@angular/router';
import { permissionGuard } from '@core/guards';

export const homeRoutes: Routes = [
  {
    path: 'home',
    children: [
      {
        path: '',
        pathMatch: 'full',
        canActivate: [permissionGuard('DispatcherHomeView')],
        loadComponent: () =>
          import('./dashboard/dashboard.component').then(
            m => m.DashboardComponent
          ),
      },
    ],
  },
];
